const MobileIllustration = () => (
  <svg
    aria-hidden="true"
    width="302"
    height="249"
    viewBox="0 0 302 249"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1871_43147)">
      <path
        d="M163.36 248.54C161.31 248.48 157.63 248.5 153.96 248.21C150.16 247.9 146.35 247.44 142.58 246.76C138.73 246.06 134.94 245.02 131.13 244.09C127.95 243.31 124.78 242.52 121.62 241.67C119.97 241.23 118.35 240.67 116.73 240.14C114.01 239.26 111.27 238.43 108.57 237.47C105.85 236.5 103.16 235.42 100.47 234.32C98.03 233.32 95.58 232.3 93.19 231.19C91.21 230.27 89.27 229.21 87.34 228.17C85.03 226.92 82.73 225.66 80.46 224.32C78.12 222.94 75.81 221.52 73.54 220.03C71.1 218.43 68.67 216.81 66.33 215.05C62.85 212.44 59.41 209.76 56.04 207C51.36 203.16 46.94 199 42.79 194.54C39.63 191.13 36.49 187.69 33.53 184.1C31.01 181.04 28.72 177.77 26.41 174.54C20.78 166.68 16.08 158.23 12.07 149.37C8.15003 140.7 5.12003 131.71 3.11003 122.38C2.12003 117.8 1.43003 113.13 0.810032 108.48C0.110032 103.3 -0.139968 98.0901 0.0900315 92.8601C0.280032 88.5001 0.360032 84.1101 0.850032 79.7801C1.35003 75.4201 2.26003 71.1101 3.05003 66.7901C4.15003 60.8201 6.11003 55.1101 8.18003 49.4601C9.32003 46.3501 10.68 43.3201 12.13 40.3601C13.87 36.8201 15.68 33.3101 17.7 29.9601C20.28 25.6801 23.29 21.7001 26.63 18.0301C29.28 15.1201 32.13 12.4501 35.23 10.0601C40.75 5.82005 46.83 2.84005 53.51 1.23005C57.43 0.280053 61.42 -0.069947 65.45 0.010053C70.79 0.110053 76.07 0.920053 81.31 1.93005C85.15 2.67005 88.97 3.58005 92.81 4.36005C96.29 5.06005 99.78 5.77005 103.28 6.33005C105.51 6.69005 107.77 6.84005 110.02 7.02005C112.38 7.21005 114.74 7.38005 117.11 7.45005C119.54 7.52005 121.97 7.48005 124.4 7.45005C126.71 7.43005 129.02 7.39005 131.33 7.34005C133.5 7.29005 135.67 7.21005 137.84 7.15005C140.71 7.07005 143.57 7.00005 146.44 6.92005C148.61 6.86005 150.78 6.76005 152.96 6.75005C156.16 6.73005 159.37 6.72005 162.57 6.81005C165.63 6.89005 168.7 7.06005 171.76 7.27005C173.68 7.40005 175.59 7.66005 177.5 7.91005C179.41 8.16005 181.33 8.39005 183.22 8.75005C186.41 9.35005 189.59 10.0001 192.76 10.7201C195.95 11.4501 199.15 12.1401 202.28 13.1201C205.81 14.2301 209.27 15.5801 212.73 16.9201C215.82 18.1201 218.89 19.3801 221.92 20.7601C224.51 21.9301 227.04 23.2601 229.56 24.6001C232.07 25.9301 234.57 27.3201 237.03 28.7601C238.95 29.8901 240.84 31.1101 242.69 32.3701C245.22 34.1001 247.73 35.8601 250.19 37.6901C252.24 39.2201 254.22 40.8601 256.22 42.4601C261.75 46.8901 266.86 51.8201 271.73 57.0001C275.88 61.4101 279.83 66.0201 283.43 70.9301C287.45 76.4101 291.04 82.1801 294 88.3501C296.86 94.3101 299.14 100.52 300.51 107.03C301.65 112.44 302.16 117.93 301.82 123.48C301.54 127.98 300.83 132.37 299.5 136.67C297.37 143.51 294.1 149.67 289.85 155.26C286.51 159.66 282.84 163.76 278.78 167.44C275 170.86 271.17 174.21 267.3 177.53C263.78 180.55 260.19 183.49 256.62 186.45C251.45 190.72 246.28 194.99 241.09 199.24C234.94 204.28 228.76 209.27 222.63 214.34C218.39 217.86 214.29 221.58 210 225.04C205.45 228.71 200.83 232.3 196.09 235.68C192.93 237.93 189.53 239.85 186.15 241.74C182.59 243.73 178.81 245.19 174.92 246.41C171.67 247.44 168.35 247.95 163.36 248.52"
        fill="#F3D500"
      />
      <path
        d="M193.43 0H199.68C206.05 0 211.21 5.16 211.21 11.53V227.11C211.21 233.48 206.05 239.61 199.68 239.61L91.29 241.55C84.92 241.55 79.76 236.39 79.76 230.02V208.5L197.45 3.87L193.43 0Z"
        fill="#4C3E7A"
      />
      <path
        d="M211.2 210.53L203.1 207.29L202.67 208.36L211.2 211.77V210.53Z"
        fill="#716595"
      />
      <path
        d="M211.2 15.2898L203.1 12.0498L202.67 13.1198L211.2 16.5298V15.2898Z"
        fill="#716595"
      />
      <path
        d="M206.58 14.7798V208.5H79.7599H79.6999L78.8199 17.6998L206.58 14.7798Z"
        fill="#D3DAF2"
      />
      <path
        d="M206.58 208.5V221.33C206.58 227.48 201.59 232.47 195.44 232.47H90.9C84.76 232.47 79.76 227.48 79.76 221.33L79.7 208.5H206.58V208.5Z"
        fill="#15958C"
      />
      <path
        d="M206.58 11.14V14.78L78.82 17.7L78.79 11.14C78.79 4.99 83.79 0 89.93 0H195.45C201.6 0 206.59 4.99 206.59 11.14H206.58Z"
        fill="#15958C"
      />
      <path
        d="M100.64 208.5L102.87 232.47H90.9C84.76 232.47 79.76 227.48 79.76 221.33L79.7 208.5H100.64V208.5Z"
        fill="#168277"
      />
      <path
        d="M81.61 3.74023L82.9 17.6002L78.82 17.7002L78.79 11.1402C78.79 8.30024 79.86 5.71023 81.61 3.74023V3.74023Z"
        fill="#168277"
      />
      <path
        d="M100.64 208.5H79.7599H79.6999L78.8199 17.6901L82.8999 17.6001L100.64 208.5Z"
        fill="#E1E6EF"
      />
      <path
        d="M134.38 7.06982H151.97"
        stroke="#4C3E7A"
        strokeWidth="1.25"
        strokeMiterlimit="10"
      />
      <path
        d="M139.92 212.31C134.84 214.05 132.64 221.18 136.16 225.52C139.1 229.15 145.5 230.16 149.29 226.93C152.53 224.16 152.63 219.32 150.29 216C148.04 212.81 143.56 211.07 139.92 212.32V212.31Z"
        stroke="#44ABA3"
        strokeWidth="1.25"
        strokeMiterlimit="10"
      />
      <path
        d="M160.74 15.8301L161.42 15.8101C113.22 63.8301 103.54 78.6801 104.11 82.3001C104.16 82.6201 104.3 82.8201 104.56 82.9601C107.67 84.5601 122 76.8001 133.51 70.5701C148.29 62.5601 153.99 59.7201 155.2 61.7001C156.65 64.0801 148.28 71.3301 127.36 88.5501C120.64 94.0801 113.7 99.8001 107.85 104.9C97.79 113.68 87.89 123.32 79.36 132.82V132.03V131.62V131.13C79.36 131.13 97.11 112.61 107.04 103.95C112.9 98.8301 119.85 93.1101 126.58 87.5701C138.43 77.8101 154.66 64.4501 154.14 62.3201C152.86 61.5101 142.03 67.3701 134.12 71.6501C118.66 80.0201 107.44 85.8101 104.01 84.0601C103.4 83.7501 103.01 83.2001 102.9 82.4801C102.57 80.3701 101.56 73.9501 159.86 15.8301"
        fill="#A8B5E6"
      />
    </g>
    <defs>
      <clipPath id="clip0_1871_43147">
        <rect width="301.91" height="248.54" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default MobileIllustration
